import { render, staticRenderFns } from "./CreateLessonFooter.vue?vue&type=template&id=150528f2&scoped=true&"
import script from "./CreateLessonFooter.vue?vue&type=script&lang=ts&"
export * from "./CreateLessonFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLessonFooter.vue?vue&type=style&index=0&id=150528f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150528f2",
  null
  
)

export default component.exports